import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import './ReviewForm.css';

const ReviewForm = ({ onReviewSubmitted }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Check URL parameters to auto-open the review form
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('review') === 'true') {
      setIsOpen(true);
      // Scroll to the review section
      setTimeout(() => {
        const reviewSection = document.querySelector('.review-form-overlay') ||
                             document.querySelector('.testimonials-section');
        if (reviewSection) {
          reviewSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);
  const [name, setName] = useState('');
  const [reviewText, setReviewText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim() || !reviewText.trim()) {
      setMessage({ text: 'Please fill in all fields', type: 'error' });
      return;
    }

    setIsSubmitting(true);
    setMessage({ text: '', type: '' });

    try {
      const { error } = await supabase
        .from('reviews')
        .insert([
          {
            name: name.trim(),
            text: reviewText.trim(),
            approved: false // Reviews start as unapproved
          }
        ])
        .select();

      if (error) throw error;

      setMessage({ text: 'Thank you! Your review has been submitted and will appear after approval.', type: 'success' });
      setName('');
      setReviewText('');
      
      // Close form after 2 seconds
      setTimeout(() => {
        setIsOpen(false);
        setMessage({ text: '', type: '' });
        if (onReviewSubmitted) onReviewSubmitted();
      }, 2000);

    } catch (error) {
      console.error('Error submitting review:', error);
      setMessage({ text: 'Failed to submit review. Please try again.', type: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) {
    return (
      <div className="review-button-container">
        <button className="leave-review-btn" onClick={() => setIsOpen(true)}>
          Leave a Review
        </button>
      </div>
    );
  }

  return (
    <div className="review-form-overlay" onClick={() => setIsOpen(false)}>
      <div className="review-form-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={() => setIsOpen(false)}>×</button>
        <h3>Leave a Review</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Your Name *</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              maxLength="50"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="review">Your Review *</label>
            <textarea
              id="review"
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
              placeholder="Share your experience working with Gita..."
              rows="6"
              maxLength="500"
              required
            />
            <span className="char-count">{reviewText.length}/500</span>
          </div>

          {message.text && (
            <div className={`message ${message.type}`}>
              {message.text}
            </div>
          )}

          <div className="form-actions">
            <button type="button" onClick={() => setIsOpen(false)} className="cancel-btn">
              Cancel
            </button>
            <button type="submit" disabled={isSubmitting} className="submit-btn">
              {isSubmitting ? 'Submitting...' : 'Submit Review'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReviewForm;

